import { NgModule } from 'ng-metadata/core';
import {PrmCitationLinker} from './citationLinker.directive';
import {CitationLinkerService} from './citationLinker.service';
import {PrmFormField} from '../infra/formBuilder/field/formField.directive';

@NgModule({
    declarations: [
       PrmCitationLinker,
        PrmFormField
    ],
    providers: [
        CitationLinkerService
    ],
    imports:[
       

    ]
})
export class CitationLinkerModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/citationLinker/citationLinker.module.ts